
    import '/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/custome-markdown.md?watch=parent';
    export const toc = [{"id":"扩展-react-markdown-使用","depth":2,"title":"扩展 react-markdown 使用"}];
export const frontmatter = {"title":"扩展 MD 渲染器使用","toc":"content","filename":"docs/guide/custome-markdown.md","lastUpdated":1752854267000,"nav":{"title":"指南","order":0},"order":2};